angular.module('picmonicng').directive('leagueBanner', [
  function () {
    return {
      restrict: 'E',
      scope: {
        league: '=',
        height: '@',
        width: '@',
      },
      template:
        '<svg class="league-banner" ng-class="{\'grayscale\': !league.league_id}" width="49" height="54" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n' +
        ' viewBox="0 0 49 54" style="enable-background:new 0 0 49 54;" xml:space="preserve">\n' +
        '<g ng-attr-filter="url({{basePath}}#filter0_d)">\n' +
        '<path fill="#E5E5E5" d="M45,1.4c0,0.4-0.2,0.7-0.4,1c-0.2,0.3-0.6,0.4-1,0.4H5.4C4.6,2.8,4,2.2,4,1.4c0-0.4,0.2-0.7,0.4-1C4.7,0.2,5,0,5.4,0h38.2C44.4,0,45,0.6,45,1.4z"/>\n' +
        '<path fill="#D1D2D7" d="M44.6,1c-0.2,0.3-0.6,0.4-1,0.4H5.4c-0.5,0-1-0.3-1.2-0.7C4.1,0.9,4,1.1,4,1.4c0,0.8,0.6,1.4,1.4,1.4h38.2c0.4,0,0.7-0.2,1-0.4c0.3-0.3,0.4-0.6,0.4-1c0-0.3-0.1-0.5-0.2-0.7C44.8,0.8,44.7,0.9,44.6,1L44.6,1z"/>\n' +
        '<path fill="#323A4D" d="M24.5,2.8V41l5.3,1.7l5.3,1.7l4.7,1.5c0.3,0.1,0.6-0.1,0.6-0.4V2.8H24.5z"/>\n' +
        '<path fill="#525F7E" d="M24.5,2.8V41l-5.3,1.7l-5.3,1.7l-4.7,1.5c-0.3,0.1-0.6-0.1-0.6-0.4V2.8H24.5z"/>\n' +
        '</g>\n' +
        '<g ng-attr-filter="url({{basePath}}#filter0_d)">\n' +
        '<path fill="#FFDF47" d="M36.8,23.4c0,6.9-5.6,12.4-12.4,12.4S12,30.3,12,23.4c0-6.9,5.6-12.4,12.4-12.4S36.8,16.5,36.8,23.4z"/>\n' +
        '</g>\n' +
        '<g ng-bind-html="league.league_id ? league.config.icon : iconHidden | safeHTML"></g>\n' +
        '<defs>\n' +
        '<filter id="filter0_d" x="0" y="0" width="49" height="54" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">\n' +
        '<feFlood flood-opacity="0" result="BackgroundImageFix"/>\n' +
        '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>\n' +
        '<feOffset dy="4"/>\n' +
        '<feGaussianBlur stdDeviation="2"/>\n' +
        '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>\n' +
        '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>\n' +
        '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>\n' +
        '</filter>' +
        '<filter id="filter1_d" x="7.96202" y="10.9478" width="32.8813" height="32.8813" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">\n' +
        '<feFlood flood-opacity="0" result="BackgroundImageFix"/>\n' +
        '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>\n' +
        '<feOffset dy="4"/>\n' +
        '<feGaussianBlur stdDeviation="2"/>\n' +
        '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>\n' +
        '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>\n' +
        '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>\n' +
        '</filter>' +
        '</defs>\n' +
        '</svg>\n',
      controller: [
        '$scope',
        function ($scope) {
          $scope.basePath = window.location.href;
          $scope.iconHidden =
            '<path d="M22.8813 26.9835H26.4879C26.8939 26.9835 27.223 26.653 27.223 26.2453V25.0746C27.223 24.8788 27.3005 24.691 27.4383 24.5525L27.7428 24.2467C27.8807 24.1083 28.0677 24.0305 28.2626 24.0305H29.4914C29.6863 24.0305 29.8733 23.9527 30.0112 23.8143L31.4183 22.4011C31.5562 22.2626 31.6336 22.0749 31.6336 21.8791V18.7994C31.6336 18.6036 31.5562 18.4158 31.4183 18.2774L30.0112 16.8641C29.8733 16.7257 29.6863 16.6479 29.4914 16.6479H20.9116C20.7167 16.6479 20.5297 16.7257 20.3918 16.8641L18.9847 18.2773C18.8468 18.4158 18.7693 18.6036 18.7693 18.7993V21.0774C18.7693 21.4852 19.0984 21.8157 19.5044 21.8157H20.9746C21.3806 21.8157 21.7097 21.4852 21.7097 21.0774V20.2758C21.7097 20.0801 21.7872 19.8923 21.925 19.7538L22.2295 19.448C22.3674 19.3096 22.5544 19.2318 22.7493 19.2318H27.286C27.481 19.2318 27.668 19.3096 27.8058 19.448L28.1103 19.7538C28.2482 19.8923 28.3256 20.0801 28.3256 20.2758V21.4465C28.3256 21.8543 27.9965 22.1848 27.5905 22.1848H25.6897C25.4948 22.1848 25.3078 22.2626 25.1699 22.401L23.0277 24.5524C22.8898 24.6909 22.8124 24.8787 22.8124 25.0745V26.9834" fill="white"/><path d="M23.5477 28.8294H26.4881C26.8941 28.8294 27.2232 29.1599 27.2232 29.5676V31.0441C27.2232 31.4519 26.8941 31.7824 26.4881 31.7824H23.5477C23.1417 31.7824 22.8126 31.4519 22.8126 31.0441V29.5676C22.8126 29.1599 23.1417 28.8294 23.5477 28.8294Z" fill="white"/>';
        },
      ],
      link: function (scope, element) {
        if (scope.height) {
          element.find('svg').attr('height', scope.height);
        }
        if (scope.width) {
          element.find('svg').attr('width', scope.width);
        }
      },
    };
  },
]);
